// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"full-stack_pageTitle__6D7Zb","pageDescription":"full-stack_pageDescription__VZqr0"};